export type ProductDetailStepsMode = 'never' | 'menu' | 'always';

const isStepsMode = (value: string | undefined): value is ProductDetailStepsMode =>
    value === 'never' || value === 'menu' || value === 'always';

/** The value shown in the editor. A saved choice wins; otherwise the prefab variant and the old menu flag. */
export const effectiveProductDetailStepsMode = (input: {
    stepsMode?: string;
    defaultVariant?: string;
    menuUsesSteps?: boolean;
}): ProductDetailStepsMode => {
    if (isStepsMode(input.stepsMode)) return input.stepsMode;
    if (input.defaultVariant === 'steps') return 'always';
    if (input.menuUsesSteps === false) return 'never';
    return 'menu';
};

/**
 * Column or steps for one item. An explicit setting wins over the prefab variant.
 * Without one, the steps variant is always steps, and a menu item stays steps unless that flag is off.
 */
export const resolveProductDetailStepsMode = (
    stepsMode: string | undefined,
    isMenu: boolean,
    layout: string | undefined,
    menuUsesSteps: boolean | undefined,
): 'column' | 'steps' => {
    const mode = isStepsMode(stepsMode) ? stepsMode : undefined;
    if (mode === 'always') return 'steps';
    if (mode === 'never') return 'column';
    if (mode === 'menu') return isMenu ? 'steps' : 'column';
    if (layout === 'steps') return 'steps';
    if (isMenu && menuUsesSteps !== false) return 'steps';
    return 'column';
};
